import React from 'react';
import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import FooterThree from '../common/footer/FooterThree';
import AboutOne from '../elements/about/AboutOne';
import TeamTwo from '../elements/team/TeamTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import Mission from "../elements/about/Mission";


const OurTeam = () => {
    return (
        <>
            <SEO title="Bayonne Voices For Progress" />
            <main className="page-wrapper">
                <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent" />
                 {/* Start Team Area  */}
                 <div className="rwt-team-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = ""
                                        title = "Our Team."
                                        description = "<br />"
                                    />
                            </div>
                        </div>
                        <TeamTwo column="col-lg-6 col-md-6 col-12" teamStyle="team-style-default style-two" />
                    </div>
                </div>

                <Separator />  

                <FooterThree />
            </main>
        </>
    )
}
export default OurTeam;